import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

export function buildCompletedDocumentDownloadApiUrl(
  token: string | undefined,
  apiBaseUrl = import.meta.env.VITE_API_BASE_PATH_ESIGN,
  pathSuffix?: string
) {
  const baseUrl = `${apiBaseUrl.replace(/\/$/, '')}/public/completed-documents`;
  const tokenUrl = token ? `${baseUrl}/${encodeURIComponent(token)}` : baseUrl;
  if (!pathSuffix) {
    return tokenUrl;
  }

  const encodedSuffix = pathSuffix.split('/').map(encodeURIComponent).join('/');
  return `${tokenUrl}/${encodedSuffix}`;
}

export default function PublicCompletedDocumentDownloadPage() {
  const { '*': pathSuffix, token } = useParams<{
    '*': string | undefined;
    token?: string;
  }>();

  useEffect(() => {
    window.location.replace(
      buildCompletedDocumentDownloadApiUrl(token, undefined, pathSuffix)
    );
  }, [pathSuffix, token]);

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        minHeight: '100vh'
      }}
    >
      <CircularProgress aria-label="Preparing document" />
    </Box>
  );
}
